module.exports = __webpack_public_path__ + "src/assets/img/plus.b4b53950dd123bdb53dbedba62fe2aa0.svg";